<!--
 * @Descripttion: 供应商订单管理
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="supplier-order">
    <BaseTabs @click="setPageType" v-model="pageType">
      <BaseTabPane label="未完结订单" name="unfinished"></BaseTabPane>
      <BaseTabPane label="已完结订单" name="finished"></BaseTabPane>
    </BaseTabs>
    <UnfinishedOrderList v-if="pageType === 'unfinished'"></UnfinishedOrderList>
    <FinishedOrderList v-if="pageType === 'finished'"></FinishedOrderList>
  </div>
</template>

<script lang="tsx" setup>
import UnfinishedOrderList from '../components/unfinished-order-list.vue';
import FinishedOrderList from '../components/finished-order-list.vue';
import { ref } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const pageType = ref('unfinished');
const setPageType = () => {
  if (route.query.orderNo) {
    // 清除路由上的查询参数
    router.replace({
      query: { force: Date.now() }
    });
  }
};
</script>
<style lang="scss"></style>
